import { handlerGetUrlParams } from '@/utils/dealUrlParams.js'
import request from '@/utils/request'

export function getAccountInfos() {
  // const url = handlerGetUrlParams('/system/user/profile', param)
  return request({
    url: '/system/user/profile',
    method: 'GET'
  })
}

// 编辑用户
export function saveAccountInfos(data) {
  return request({
    url: '/system/user/profile',
    method: 'PUT',
    data
  })
}

// 修改密码
export function updatePwd(data) {
  const url = handlerGetUrlParams('/system/user/profile/updatePwd', data)
  return request({
    url: url,
    method: 'PUT',
    data
  })
}

// 上传
export function upload(data) {
  return request({
    url: '/bus/financial/pop',
    method: 'POST',
    headers: {
      'Content-Type': 'multipart/form-data'
    },
    data
  })
}
export function addUser(data) {
  return request({
    url: '/system/user',
    method: 'POST',
    data
  })
}

export function getUserInfo() {
  return request({
    url: '/check/token/getUserInfo',
    method: 'GET',
  })
}
